import loadable from '@loadable/component';

// 懒加载组件
const LicenseManagement = loadable(() => import('./supLicense/licenseManagement/LicenseManagement'));
const DocumentLicenseManagement = loadable(() => import('./supLicense/documentLicenseManagement/DocumentLicenseManagement'));
const FactoryManagement = loadable(() => import('./supLicense/factoryManagement/FactoryManagement'));
const AgentManagement = loadable(() => import('./supLicense/agentManagement/AgentManagement'));
const ProductLicenseManagement = loadable(() => import('./supLicense/productLicenseManagement/ProductLicenseManagement'));
const ItemLicenseNewApplication = loadable(() => import('./supProduct/itemLicenseNewApplication/ItemLicenseNewApplication'));
const FactoryApplictionManagement = loadable(() => import('./supProduct/factoryNewApplication/FactoryManagement'));

export const subRoutes = [
  {
    path: '/LicenseManagement',
    component: LicenseManagement
  },
  {
    path: '/DocumentLicenseManagement',
    component: DocumentLicenseManagement
  },
  {
    path: '/FactoryManagement',
    component: FactoryManagement
  },
  {
    path: '/ProductLicenseManagement',
    component: ProductLicenseManagement
  },
  {
    path: '/AgentManagement',
    component: AgentManagement
  },
  {
    path: '/ItemLicenseNewApplication',
    component: ItemLicenseNewApplication
  },
  {
    path: '/FactoryApplictionManagement',
    component: FactoryApplictionManagement
  }
];
